import React from "react";
import { Link } from "react-router-dom";
import "./css/Footer.css";
const Footer = () => {   
  return (
      <div id="footer-nav">
       <nav className="navbar fixed-bottom navbar-dark navbar-expand-md bg-dark justify-content-md-center justify-content-start footer-nav">   
      <div
          className="navbar-collapse  justify-content-between align-items-center w-100"
          id="collapsingNavbar2"
        >
          <ul className="navbar-nav mx-auto text-md-center ">
            <li className="nav-item    ">
              <Link className="nav-link" aria-current="page" to="/">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  className="bi bi-house-door"
                  viewBox="0 0 16 16"
                >
                  <path d="M8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4.5a.5.5 0 0 0 .5-.5v-4h2v4a.5.5 0 0 0 .5.5H14a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146zM2.5 14V7.707l5.5-5.5 5.5 5.5V14H10v-4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v4H2.5z" />
                </svg>
              </Link>
            </li>
            <li className="nav-item    ">
              <Link className="nav-link" to="/complaintform">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  className="bi bi-ui-checks-grid"
                  viewBox="0 0 16 16"
                >
                  <path d="M2 10h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1zm9-9h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zm0 9a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-3zm0-10a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2h-3zM2 9a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H2zm7 2a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-3zM0 2a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm5.354.854a.5.5 0 1 0-.708-.708L3 3.793l-.646-.647a.5.5 0 1 0-.708.708l1 1a.5.5 0 0 0 .708 0l2-2z" />
                </svg>
              </Link>
            </li>
            <li className="nav-item    ">
              <Link className="nav-link" to="/complaints">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  className="bi bi-pie-chart-fill"
                  viewBox="0 0 16 16"
                >
                  <path d="M15.985 8.5H8.207l-5.5 5.5a8 8 0 0 0 13.277-5.5zM2 13.292A8 8 0 0 1 7.5.015v7.778l-5.5 5.5zM8.5.015V7.5h7.485A8.001 8.001 0 0 0 8.5.015z" />
                </svg>
              </Link>
            </li>
          </ul>
          {/* <ul className="nav navbar-nav flex-row justify-content-md-center justify-content-start flex-nowrap">
            <li className="nav-item"><a className="nav-link" href=""><i className="fa fa-facebook mr-1"></i></a> </li>
            <li className="nav-item"><a className="nav-link" href=""><i className="fa fa-twitter"></i></a> </li>
        </ul> */}
        </div>
      </nav>
    </div>
  );
};

export default Footer;
   